import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Custom icon: Avvo
export const faAvvo = {
  prefix: 'fac' as IconDefinition['prefix'],
  iconName: 'avvo' as IconDefinition['iconName'],
  icon: [
    17,
    17,
    [],
    '',
    'M8.5 2.25 13.76 14.75h-2.43l-1.04-2.52H6.7L5.67 14.75H3.24L8.5 2.25Zm-1.04 7.92h2.08L8.5 7.47l-1.04 2.7Z',
  ],
} as IconDefinition;

// Custom icon: Cornell LII wordmark
export const faLii = {
  prefix: 'fac' as IconDefinition['prefix'],
  iconName: 'lii' as IconDefinition['iconName'],
  icon: [
    544,
    448,
    [],
    '',
    'M32 0c17.7 0 32 14.3 32 32l0 352 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32L0 32c0-17.7 14.3-32 32-32zM384 0c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM512 0c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32z',
  ],
} as IconDefinition;
